<template>
  <ConfirmDialog group="delete">
    <template #container="{ message, acceptCallback, rejectCallback }">
      <div class="w-full max-w-lg">
        <div class="flex flex-col items-center gap-4 p-5">
          <div class="w-max rounded-lg bg-red-50 p-2.5">
            <RiErrorWarningFill class="size-5 text-red-500" />
          </div>
          <div class="space-y-1 text-center">
            <div class="text-lg font-medium text-surface-950">
              {{ message.header }}
            </div>
            <div class="whitespace-pre-line text-surface-600">
              {{ message.message }}
            </div>
          </div>
        </div>
        <div class="flex justify-end gap-2 border-t border-surface-200 p-5">
          <Button
            :label="
              message.rejectLabel ?? $t('global.delete-confirm-dialog.cancel')
            "
            severity="secondary"
            outlined
            @click="rejectCallback"
          />
          <Button
            :label="
              message.acceptLabel ?? $t('global.delete-confirm-dialog.delete')
            "
            severity="danger"
            @click="acceptCallback"
          />
        </div>
      </div>
    </template>
  </ConfirmDialog>

  <ConfirmDialog group="warning">
    <template #container="{ message, acceptCallback, rejectCallback }">
      <div class="w-full max-w-lg">
        <div class="flex flex-col items-center gap-4 p-5">
          <div class="w-max rounded-lg bg-red-50 p-2.5">
            <RiAlertFill class="size-5 text-primary-500" />
          </div>
          <div class="space-y-1 text-center">
            <div class="text-lg font-medium text-surface-950">
              {{ message.header }}
            </div>
            <div class="whitespace-pre-line text-surface-600">
              {{ message.message }}
            </div>
          </div>
        </div>
        <div class="flex justify-end gap-2 border-t border-surface-200 p-5">
          <Button
            :label="$t('global.warning-confirm-dialog.cancel')"
            severity="secondary"
            outlined
            @click="rejectCallback"
          />
          <Button
            :label="$t('global.warning-confirm-dialog.continue')"
            @click="acceptCallback"
          />
        </div>
      </div>
    </template>
  </ConfirmDialog>
</template>

<script setup lang="ts">
import RiErrorWarningFill from '~icons/ri/error-warning-fill'
import RiAlertFill from '~icons/ri/alert-fill'
</script>
